import { bindActionCreators } from 'redux';
import { mapValues, isFunction, pickBy, has, get } from 'lodash';
import queryString from 'qs';

const bindState = (defaultState, state) =>
  mapValues(defaultState, value => (isFunction(value) ? value(state) : value));

export const defaultStateForMapStateToProps = defaultState => (
  state,
  ownProps
) => {
  const query = get(state, 'router.location.search', '').slice(1);
  const segmentUUid = get(queryString.parse(query), 'segment', null);
  return {
    ...bindState(defaultState, state),
    ...pickBy(ownProps, (value, key) => has(defaultState, key)),
    segmentUUid
  };
};

export const defaultActionsForMapDispatchToProps = defaultActions => (
  dispatch,
  ownProps
) => ({
  ...bindActionCreators(defaultActions, dispatch),
  ...pickBy(ownProps, (value, key) => has(defaultActions, key))
});

export default {
  defaultStateForMapStateToProps,
  defaultActionsForMapDispatchToProps
};
